// src/components/Navigation.js
import React, { useState } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { FaUserCircle, FaSignOutAlt, FaUserCog, FaUserLock, FaCommentDots } from 'react-icons/fa'
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import ContactModal from "../pages/ContactModal ";

const Navigation = ({ isAuthenticated, onLogout }) => {
  const [showContactModal, setShowContactModal] = useState(false);
  // Modal Handlers
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);
  const navigate = useNavigate();

  // Handle logout and navigate to login page
  const handleLogout = () => {
    localStorage.removeItem("auth");
    onLogout(); // Clear authentication state
    navigate("/login"); // Redirect to login page after logout
  };

  return (
    <>
      <Navbar collapseOnSelect className="navbar navbar-default navbar-gradient navbar-textHilight" fixed="top" expand="lg">
        <Container fluid>
          <Navbar.Brand as={Link} to="/" className="navbar-brand page-scroll">
            <img src="/ereceiptLogo.png" // Path to your image
              alt="E-Receipt Logo"
              height="40" // Adjust the size as needed
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              {!isAuthenticated ? (
                <>
                  <Nav.Link as={Link} to="/">Home</Nav.Link>
                  <Nav.Link as={Link} to="/about">About Us</Nav.Link>
                  <Nav.Link as={Link} to="/how-it-works">See How It Works</Nav.Link>
                  <Nav.Link onClick={handleShowContactModal} style={{ cursor: "pointer" }}>Contact Us</Nav.Link>
                  <Button variant="warning" as={Link} to="/demo-request">Let's see it in action</Button>
                  <Button variant="light" as={Link} to="/login">Member Login</Button>
                </>
              ) : (
                <>
                  <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
                  <Nav.Link as={Link} to="/my-receipts">My Receipts</Nav.Link>
                  <Dropdown align="end">
                    <Dropdown.Toggle id="dropdown-profile" className="d-flex align-items-center">
                      <FaUserCircle size={24} style={{ marginRight: "8px" }} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="shadow-lg border-0">
                      <Dropdown.Item as={Link} to="/my-acount">
                        <FaUserCog size={20} style={{ marginRight: "8px" }} />My Account
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item as={Link} to="/chg-pwd">
                        <FaUserLock size={20} style={{ marginRight: "8px" }} />  Password & Security
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item as={Link} to="/febak">
                        <FaCommentDots size={20} style={{ marginRight: "8px" }} />
                        Give Feedback
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={handleLogout} >
                        <FaSignOutAlt size={20} style={{ marginRight: "8px" }} />
                        Log Out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <ContactModal
        show={showContactModal}
        handleClose={handleCloseContactModal}
      />
    </>
  );
};

export default Navigation;
